import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { FuncionarioAssinatura } from "../../models/funcionario_assinatura";
import { IGetFuncionarioAssinaturasUseCase } from "../../../presentation/useCases/read/get_funcionario_assinaturas_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFuncionarioAssinaturasUseCase
 */

export class GetFuncionarioAssinaturasUseCase extends BasePaginatedUseCase<FuncionarioAssinatura> implements IGetFuncionarioAssinaturasUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getFuncionarioAssinaturas(
    idFuncionario: number,
    status: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getFuncionarioAssinaturas(
      idFuncionario,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}